/**
 * BGG User class
 * 
 * Represents a BoardGameGeek user with their profile information.
 */
class BggUser {
    constructor(username, name, id, city, state, tradelist, wishlist, playlist) {
        this.username = username;
        this.name = name;
        this.id = id;
        this.city = city;
        this.state = state;
        this.tradelist = tradelist || [];
        this.playlist = playlist || [];
        this.wishlist = wishlist || [];
    }
}

export default BggUser;